import { Catalog as CatalogDict } from '@/shared/i18n';
import { CatalogEvents } from '../../events';
import { CatalogViewData } from '../../types/catalog-view-data';
import { CourseList } from './catalog-courses-list';
import { CourseDataFilters } from '../../types/filtered-data';
import { EventBus } from '@/shared/utils';
import { ICourseData } from '../../types/course-data';
import { Instrument } from '../../types/instrument';
import { InstrumentsFilterDesktop, SidebarFilterDesktop } from '../filter/filter-desktop';
import { FilterMobile } from '../filter/filter-mobile';

interface CoursesSectionProps {
  dict: CatalogDict;
  eventBus: EventBus<CatalogEvents>;
  filters: any;
  activeFilters: CourseDataFilters;
  parentInstruments: Instrument[];
  instrumentsFilterOnChange: (checked: boolean, instrument: any) => void;
  filteringCatalogData: boolean;
  loadingCatalogData: boolean;
  filteredItems: ICourseData[];
  categories: CatalogViewData['categories'];
  handleSkillLevelsChange: (selectedLevels: string[] | null) => void;
  handleGenresChange: (genre: string, checked: boolean) => void;
  handleTopicsChange: (topic: string, checked: boolean) => void;
  handleTypeChange: (type: string, checked: boolean) => void;
  lastCourseElementRef: (node: HTMLElement | null) => void;
  onFavoriteChange?: (courseId: string, favouriteId: string | undefined) => void;
  isEnrichingData?: boolean;
  filterLoading?: boolean;
  useSkeleton?: boolean;
  onResetSidebarFilters: () => void;
  isAnyFilterActive: boolean;
}

export const CoursesSection: React.FC<CoursesSectionProps> = ({
  dict,
  eventBus,
  filters,
  activeFilters,
  parentInstruments,
  instrumentsFilterOnChange,
  lastCourseElementRef,
  filteringCatalogData,
  loadingCatalogData,
  filteredItems,
  categories,
  handleSkillLevelsChange,
  handleGenresChange,
  handleTopicsChange,
  handleTypeChange,
  onFavoriteChange,
  isEnrichingData = false,
  filterLoading = false,
  useSkeleton = false,
  onResetSidebarFilters,
  isAnyFilterActive,
}) => {
  return (
    <div className="mt-10 space-y-8">
      <div className="flex flex-col w-full gap-4">
        <InstrumentsFilterDesktop
          parentInstruments={parentInstruments}
          activeFilters={activeFilters}
          filters={filters}
          instrumentsFilterOnChange={instrumentsFilterOnChange}
          isEnrichingData={filterLoading}
        />
        <FilterMobile
          dict={dict}
          filterData={filters}
          activeFilters={activeFilters}
          instrumentsFilterOnChange={instrumentsFilterOnChange}
          handleSkillLevelsChange={handleSkillLevelsChange}
          handleGenresChange={handleGenresChange}
          handleTopicsChange={handleTopicsChange}
          handleTypeChange={handleTypeChange}
          isEnrichingData={filterLoading}
          onResetSidebarFilters={onResetSidebarFilters}
          isAnyFilterActive={isAnyFilterActive}
        />
      </div>
      <div className="items-start w-full sm:flex gap-x-6">
        <SidebarFilterDesktop
          dict={dict}
          eventBus={eventBus}
          filters={filters}
          activeFilters={activeFilters}
          instrumentsFilterOnChange={instrumentsFilterOnChange}
          handleSkillLevelsChange={handleSkillLevelsChange}
          handleGenresChange={handleGenresChange}
          handleTopicsChange={handleTopicsChange}
          handleTypeChange={handleTypeChange}
          isEnrichingData={filterLoading}
          onResetSidebarFilters={onResetSidebarFilters}
          isAnyFilterActive={isAnyFilterActive}
        />
        <div className="flex-1 space-y-10 overflow-hidden">
          <CourseList
            dict={dict}
            eventBus={eventBus}
            filteringCatalogData={filteringCatalogData}
            loadingCatalogData={loadingCatalogData}
            filteredItems={filteredItems}
            categories={categories}
            lastCourseElementRef={lastCourseElementRef}
            onFavoriteChange={onFavoriteChange}
            isEnrichingData={isEnrichingData}
            useSkeleton={useSkeleton}
          />
        </div>
      </div>
    </div>
  );
};
